import { useRef, useEffect, useState } from "react";
import LatestNews from "./LatestNews";

// Use public paths for production build compatibility
// process.env.PUBLIC_URL is empty in development, but includes the base path in production
const basePath = process.env.PUBLIC_URL || '';
const shikshaSangamaPdf = `${basePath}/images/events/KCE-SHIKSHA-SANGAMA.pdf`;
const shikshaSangamaImage = `${basePath}/images/events/KCE-SHIKSHA-SANGAMA.jpg`;
const shikshaSangamaVideo = `${basePath}/images/events/KCE-SHIKSHA-SANGAMA.mp4`;

const UpcomingEvents = ({ hideHeading = false, hideLatestNews = false }) => {
  const videoRef = useRef(null);
  const [eventImages, setEventImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch event images dynamically
  useEffect(() => {
    const fetchEventImages = async () => {
      try {
        // Try JSON file first (works in development/localhost)
        let response = await fetch('/images/events/images.json');
        let data = null;
        
        if (response.ok) {
          const text = await response.text();
          // Check if it's valid JSON or PHP code
          if (text.trim().startsWith('<?php') || text.trim().startsWith('<!')) {
            // This shouldn't happen with JSON, but if it does, try PHP
            response = await fetch('/images/events/images.php');
            if (response.ok) {
              const phpText = await response.text();
              if (!phpText.trim().startsWith('<?php') && !phpText.trim().startsWith('<!')) {
                data = JSON.parse(phpText);
              }
            }
          } else {
            // Valid JSON
            data = JSON.parse(text);
          }
        } else {
          // JSON doesn't exist, try PHP (for production server)
          response = await fetch('/images/events/images.php');
          if (response.ok) {
            const text = await response.text();
            // Check if PHP was executed (should be JSON) or raw PHP code
            if (!text.trim().startsWith('<?php') && !text.trim().startsWith('<!')) {
              data = JSON.parse(text);
            }
          }
        }
        
        if (data && data.images && data.images.length > 0) {
          // Filter out the main SHIKSHA SANGAMA image (we show it separately)
          const otherImages = data.images.filter(img => 
            !img.includes('KCE-SHIKSHA-SANGAMA.jpg')
          );
          setEventImages(otherImages);
        } else {
          setEventImages([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error loading event images:', error);
        setLoading(false);
        setEventImages([]);
      }
    };

    fetchEventImages();
  }, []);

  useEffect(() => {
    const playVideo = async () => {
      if (videoRef.current) {
        try {
          await videoRef.current.play();
        } catch (error) {
          // Browser may block autoplay with sound - try again after a short delay
          setTimeout(() => {
            if (videoRef.current) {
              videoRef.current.play().catch(() => {
                // Autoplay blocked - user will need to click play
              });
            }
          }, 500);
        }
      }
    };

    playVideo();
  }, []);
  return (
    <section className="ftco-section ftco-no-pb">
<div className="container">
{!hideHeading && (
  <div className="row justify-content-center pb-4">
    <div className="col-md-12  heading-section ftco-animate text px-4">
      <h2 className="mb-4 text-success text-center">
        <span className="text-warning">Upcoming </span> Events
      </h2>   
    </div>
  </div>
)}
    
  <div className="row mt-3">
    <div className=" col-md-12 order-md-first">
      <div className="text px-4 heading-section">
        
      <h2 className="mb-4 text-center"><span>KCE - </span> SHIKSHA SANGAMA </h2>
      <h3 className="mb-4 text-center"><span className="text-success">24<sup>th</sup> & 25<sup>th</sup> March 2026</span></h3>

      <div className="row g-4 align-items-start mb-4">
        <div className="col-12 col-lg-6">
          <div className="ratio ratio-16x9 rounded overflow-hidden">
            <video
              ref={videoRef}
              className="w-100"
              controls
              autoPlay
              playsInline
              preload="auto"
              
            >
              <source src={shikshaSangamaVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <div className="ratio ratio-16x9 rounded overflow-hidden bg-white">
            <img
              src={shikshaSangamaImage}
              alt="KCE - SHIKSHA SANGAMA 2026"
              className="w-100 h-300 object-fit-contain"
            />
          </div>

          <div className="mt-3 d-flex gap-2 flex-wrap">
            <a className="btn btn-primary" href={shikshaSangamaPdf} target="_blank" rel="noreferrer">
              View PDF
            </a>
            <a className="btn btn-outline-primary" href={shikshaSangamaPdf} download>
              Download PDF
            </a>
          </div>
        </div>
      </div>

      {/* Display other event images */}
      {!loading && eventImages.length > 0 && (
        <div className="row mt-4">
          <div className="col-12">
            <h3 className="mb-3 text-center">Event Invitation</h3>
            <div className="row g-3">
              {eventImages.map((image, index) => {
                const encodedImage = encodeURI(image);
                return (
                  <div key={index} className="col-12 col-md-6 col-lg-4">
                    <div className="ratio ratio-16x9 rounded overflow-hidden bg-white">
                      <img
                        src={encodedImage}
                        alt={`Event photo ${index + 1}`}
                        className="w-100 h-100 object-fit-contain"
                        style={{ objectFit: 'contain' }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
                         
      {!hideLatestNews && <LatestNews/>}
                          
        </div>
    </div>

  
  </div>  
  </div>
  <hr className="custom-hr"/> 
    </section>
  );
};

export default UpcomingEvents;
